import React from 'react';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

/**
 * Spacer Component
 * Provides consistent vertical or horizontal spacing between components
 * 
 * @param {Object} props - Component props
 * @param {'vertical'|'horizontal'} props.direction - Direction of spacing
 * @param {number} props.size - Size multiplier for theme spacing
 * @param {Object} props.sx - Additional styling
 */
const Spacer = ({ 
  direction = 'vertical', 
  size = 4, 
  sx = {},
  ...props 
}) => {
  const theme = useTheme();
  
  const spacingValue = theme.spacing(size);
  
  const spacerSx = {
    ...(direction === 'vertical' && {
      height: spacingValue,
      width: '100%',
    }),
    ...(direction === 'horizontal' && {
      width: spacingValue,
      height: '100%',
    }),
    ...sx,
  };

  return <Box sx={spacerSx} {...props} />;
};

export default Spacer;
